import * as React from "react";
import { Select } from "antd";
import { useContext, useState, useEffect } from "react";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { FormComponentProps } from "antd/lib/form";
import { ServiceContext } from "src/services/provider/Service.provider";
import { IFillSelect } from "src/services/interfaces/generic/IFillSelect";
import * as _ from 'lodash';

interface ISelectNatureProps extends FormComponentProps {
  value: number;
  isNatureRequired: boolean;
  onChange: (nature: IFillSelect) => void;
}

export const SelectNature: React.FC<ISelectNatureProps> = ({ form, isNatureRequired, onChange, value }) => {
  const { NatureTypeService } = useContext(ServiceContext);
  const [natures, setNatures] = useState<IFillSelect[]>([]);

  const Option = Select.Option;

  const clearFields = () => {
    setNatures([]);
    form.setFieldsValue({
      ddlCourt: ""
    });
  };
  useEffect(() => {
    clearFields();
    fetchNature();
  }, []);

  function fetchNature() {
    NatureTypeService.getAll()
      .then(setNatures);
  }

  return (
    <PbrSelect
      name="nature"
      size="large"
      formItemProps={{ label: `Natureza` }}
      formWrapper={form}
      showSearch
      value={value}
      placeholder="Selecione a natureza"
      onChange={e => onChange(natures?.find(f => f.id === _.toNumber(e)))}
      rules={[{ required: isNatureRequired, message: "Informe a natureza" }]}
    >
      {natures?.map((e, i) => (
        <Option key={i.toString()} value={e.id}>{`${e.name}`}</Option>
      ))}
    </PbrSelect>
  );
}




// WEBPACK FOOTER //
// ./src/components/common/SelectNature/SelectNature.tsx